export let EventImageType = /*#__PURE__*/function (EventImageType) {
  EventImageType["MAIN_IMAGE"] = "MAIN_IMAGE";
  EventImageType["DESCRIPTION"] = "DESCRIPTION";
  return EventImageType;
}({});
//# sourceMappingURL=fetch-events.js.map